import { render } from "./Start2.vue?vue&type=template&id=3098880c&scoped=true"
import script from "./Start2.vue?vue&type=script&lang=js"
export * from "./Start2.vue?vue&type=script&lang=js"

import "./Start2.vue?vue&type=style&index=0&id=3098880c&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3098880c"]])

export default __exports__